const ft_usersettings_showNoAndSv =
      window && window.location && /ft_usersettings_showNoAndSv=true/.test(window.location.href);

const LOCALES = [
    'cs-CZ',
    'da-DK',
    'de-DE',
    'en-GB',
    'es-ES',
    'et-EE',
    'fr-FR',
    'it-IT',
    'lt-LT',
    'lv-LV',
    'nl-NL',
    'pl-PL',
    'pt-PT',
    'ro-RO',
    'sk-SK',
].concat(ft_usersettings_showNoAndSv ? ['no-NO', 'sv-SE'] : []).filter(Boolean);

LOCALES.sort();

export default LOCALES;
